import React from "react";
import { JackpotIznos } from './JackpotIznos.jsx';
import RiveComponent from "../../Components/Shared/RiveComponent";

export class GameImage extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        const imgsrc = casino.config.gameImagesUrl + this.props.brands[this.props.igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(this.props.igra.n);
        const webP = casino.config.canIUseWebP ? '.webp' : '.jpeg';
        const cache = '?c=' + casino.config.guiCacheVerzija;
        let imgBig = imgsrc + webP + cache;
        let imgSmall = imgsrc + '-m' + webP + cache;
        const appIconSmall = imgsrc + '-xicon-m' + webP + cache;
        var artboard = this.props.artboard;

        // --- Vertical images (mobile only) ---
        let isVertical = this.props.isVerticalImage === true;

        // Ako je vertical → override URL-ove
        if (isVertical) {
            const jpg = '.jpeg';
            imgBig = imgsrc + '-xvertical' + jpg + cache;
            imgSmall = imgsrc + '-xvertical' + jpg + cache;
        }
        
        return (
            <div className="relative">
                <div className={`relative ${this.props.igra?.p?.includes("gc") ? "has-golden-coins" : ""}`}>
                    {this.props.igra?.p?.includes("o") && (
                        <div className={"maintenance-overlay " + (this.props.iconImage ? 'icon-image' : '')}>
                            <div className="icon"></div>
                            <div className="info">Održavanje u tijeku</div>
                        </div>
                    )}

                    {this.props.igra?.p?.includes("o") && (
                        <>
                            {this.props.iconImage ? (
                                <div>
                                    <div data-lazyid={this.props.igra.s} className={"game-img game-img-icon" + (this.props.goLazyImage ? " lazy" : "")}
                                        style={{ 'backgroundImage': `url("${appIconSmall}"), url("${imgSmall}")` }} />
                                </div>
                            ) : this.props.bigPicture === "true" ? (
                                <div data-lazyid={this.props.igra.s} className="game-img" style={{ 'backgroundImage': `url("${imgBig}"), url("${imgBig}")` }} />
                            ) : (
                                <div>
                                    <div data-lazyid={this.props.igra.s} className={"game-img" + (this.props.goLazyImage ? " lazy" : "")} style={{ 'backgroundImage': `url("${imgSmall}")` }} />
                                </div>
                            )}
                        </>
                    )}

                    {!this.props.isRive && !this.props.igra?.p?.includes("o") && (
                        <>
                            {this.props.iconImage ? (
                                <div>
                                    <div data-lazyid={this.props.igra.s} className={"game-img game-img-icon" + (this.props.goLazyImage ? " lazy" : "")}
                                        style={{ 'backgroundImage': `url("${appIconSmall}"), url("${imgSmall}")` }} />
                                </div>
                            ) : this.props.bigPicture === "true" ? (
                                <div data-lazyid={this.props.igra.s} className="game-img" style={{ 'backgroundImage': `url("${imgBig}"), url("${imgBig}")` }} />
                            ) : (
                                <div>
                                    <div data-lazyid={this.props.igra.s} className={"game-img" + (this.props.goLazyImage ? " lazy" : "")} style={{ 'backgroundImage': `url("${imgSmall}")` }} />
                                </div>
                            )}
                        </>
                    )}
                    
                    {(!this.props.igra.p || !this.props.igra.p.includes("o")) && this.props.isRive && this.props.riveSrc && artboard && (
                        <div className="rive-container">
                            <div className="rive-offset">
                                <RiveComponent
                                    lazyLoad={true}
                                    cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                    src={this.props.riveSrc}
                                    stateMachines="State Machine 1"
                                    artboard={artboard}
                                    useOffscreenRenderer={true}
                                    width="664"
                                    height="460"
                                    playRequest={true}
                                    disablePlayOutsideViewport={{ rootMargin: "-50px 0px 0px 0px" }}
                                />
                            </div>
                        </div>
                    )}

                    {this.props.igra?.p?.includes("n") && !this.props.igra.p.includes("ex") && <span className="novo-badge"></span>}
                    {!this.props.iconImage && this.props.igra?.p?.includes("daw") && <span className="drops-n-wins"></span>}
                    {!this.props.iconImage && this.props.igra?.p?.includes("cc") && <span className="egt-clover-chance"></span>}
                    {!this.props.iconImage && this.props.igra?.p?.includes("bl") && <span className="egt-bell-link"></span>}
                    {!this.props.iconImage && this.props.igra?.p?.includes("gak") && <span className="gods-and-kings"></span>}
                    {!this.props.iconImage && this.props.igra?.p?.includes("gcl") && <span className="golden-coins-link"></span>}
                    {this.props.igra?.p?.includes("md") && <span className="mystery-drop"></span>}
                    {this.props.igra?.p?.includes("jr") && <span className="jackpot-rain-ribbon"></span>}
                    {this.props.igra?.p?.includes("sg") && <span className="spin-gifts-badge"></span>}
                    {this.props.igra?.p?.includes("pp") && <span className="pateplay-badge"></span>}
                    {this.props.igra?.p?.includes("ex") && <span className="exclusive-badge"></span>}
                    {this.props.igra?.p?.includes("br") && <span className="barlink-badge"></span>}

                    {this.props.igra?.jpName && (
                        <span className={'jackpotName-badge ' + this.props.igra.jpName.toString().toLowerCase()}>{this.props.igra.jpName}</span>
                    )}
                </div>
                {this.props.igra?.jpIznos && (
                    <div className="margin-top-xsmall margin-bottom-xsmall">
                        <JackpotIznos iznos={this.props.igra.jpIznos}></JackpotIznos>
                    </div>
                )}
            </div>
        );
    }
};